import React from 'react'

import Tick from '../../images/integration-pages/tick.png'
import Wrong from '../../images/integration-pages/wrong.png'

const ComparisonTable = ({
    integrationApp,
    websiteIntegrationArray,
    integrationArray,
    pricingArray,
    campaignsArray,
}) => {

    return (
        <>
            <section className="w-full px-2 pt-5 pb-5 mx-auto text-center lg:w-4/5 xs:px-4">
                <div className='space-y-4'>
                    <h2 className="text-lg font-semibold md:text-xl lg:text-32px font-poppins lg:leading-50px" style={{color: '#2D2D2D'}}> <span className='text-primary'>Optinly </span>Vs {integrationApp}</h2>
                    <p className='text-sm font-normal md:text-base lg:text-lg font-roboto' style={{color: '#4B4B4B'}}>Conversion focused popup tool kit with essential and advanced features</p>
                </div>

                <div className='flex flex-col w-full my-10 flex-nowrap'>

                    {/* Table Head */}
                    <div className='py-3.5 md:py-6 flex flex-row items-center'>
                        <h3 className='w-1/3 mx-auto text-lg font-medium md:text-2xl xl:text-28px font-poppins text-dark_blue'>Features</h3>
                        <h3 className='w-1/3 mx-auto text-lg font-medium md:text-2xl xl:text-28px font-poppins text-primary'>Optinly</h3>
                        <h3 className='w-1/3 mx-auto text-lg font-medium md:text-2xl xl:text-28px font-poppins text-dark_blue'>{integrationApp}</h3>
                    </div>

                    {/* Table Sub Heading Website Integrations*/}
                    <div className='w-full' style={{backgroundColor: '#F5F9FF'}}>
                        <div className='flex flex-row items-center w-full mx-auto rounded-md xl:w-4/5'>
                            <div className='py-2 text-lg font-bold text-left xl:w-1/3 text-primary font-roboto md:text-xl xl:text-2xl'>Website Integrations</div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                        </div>
                    </div>
                    
                    <div className='mt-2'>
                        {
                            websiteIntegrationArray.map((item, index) => {
                                return(
                                    <div className='flex flex-row items-center w-full py-3 mx-auto xl:w-4/5'>
                                        <div className='w-1/3 text-left'>
                                            <div className='pl-2 text-sm font-normal xl:pl-0 md:text-base xl:text-lg font-roboto'>{item.title}</div>
                                        </div>
                                        <div className='w-1/3 mx-auto'>
                                            <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.optinly ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                        </div>
                                        <div className='w-1/3 pr-10 text-right md:pr-32 lg:pr-20'>
                                            <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.integrationApp ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    {/* Table Sub Heading Integrations*/}
                    <div className='w-full mt-4' style={{backgroundColor: '#F5F9FF'}}>
                        <div className='flex flex-row items-center w-full mx-auto rounded-md xl:w-4/5'>
                            <div className='w-full py-2 text-lg font-bold text-left xl:w-1/3 lg:mx-auto text-primary font-roboto md:text-xl xl:text-2xl'>Integrations</div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                        </div>
                    </div>
                    
                    <div className='mt-2'>
                        {
                            integrationArray.map((item, index) => {
                                return(
                                    <div className='flex flex-row items-center w-full py-3 mx-auto xl:w-4/5'>
                                        <div className='w-1/3 text-left'>
                                            <div className='pl-2 text-sm font-normal xl:pl-0 md:text-base xl:text-lg font-roboto'>{item.title}</div>
                                        </div>
                                        <div className='w-1/3 mx-auto'>
                                            <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.optinly ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                        </div>
                                        <div className='w-1/3 pr-10 text-right md:pr-32 lg:pr-20'>
                                            <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.integrationApp ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    {/* Table Sub Heading Pricing*/}
                    <div className='w-full mt-4' style={{backgroundColor: '#F5F9FF'}}>
                        <div className='flex flex-row items-center w-full mx-auto rounded-md xl:w-4/5' style={{backgroundColor: '#F5F9FF'}}>
                            <div className='w-full py-2 text-lg font-bold text-left xl:w-1/3 lg:mx-auto text-primary font-roboto md:text-xl xl:text-2xl'>Pricing</div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                        </div>
                    </div>
                    <div className='mt-2'>
                        {
                            pricingArray.map((item, index) => {
                                return(
                                    <div className='flex flex-row items-center w-full py-3 mx-auto xl:w-4/5'>
                                        <div className='w-1/3 text-left'>
                                            <div className='pl-2 text-sm font-normal xl:pl-0 md:text-base xl:text-lg font-roboto'>{item.title}</div>
                                        </div>
                                        <div className='w-1/3 mx-auto'>
                                            {typeof item.optinly != 'boolean' ? 
                                                <div className='pl-2 text-sm font-normal xl:pl-0 md:text-base xl:text-lg font-roboto'>{item.optinly}</div>
                                                :
                                                <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.optinly ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                            }
                                        </div>

                                        {typeof item.integrationApp != 'boolean' ? 
                                            <div className='w-1/3 pr-5 text-sm font-normal text-right md:pr-24 xl:pr-10 md:text-base xl:text-lg font-roboto'>{item.integrationApp}</div>
                                            :    
                                            <div className='w-1/3 pr-10 text-right md:pr-32 lg:pr-20'>
                                                <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.integrationApp ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>

                    {/* Table Sub Heading Campaign*/}
                    <div className='w-full mt-4' style={{backgroundColor: '#F5F9FF'}}>
                        <div className='flex flex-row items-center w-full mx-auto rounded-md xl:w-4/5' style={{backgroundColor: '#F5F9FF'}}>
                            <div className='w-full py-2 text-lg font-bold text-left xl:w-1/3 lg:mx-auto text-primary font-roboto md:text-xl xl:text-2xl'>Campaigns</div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                            <div className='w-0 py-2 mx-auto text-left xl:w-1/3 lg:text-center'></div>
                        </div>
                    </div>
                    
                    <div className='mt-2'>
                        {
                            campaignsArray.map((item, index) => {
                                return(
                                    <div className='flex flex-row items-center w-full py-3 mx-auto xl:w-4/5'>
                                        <div className='w-1/3 text-left'>
                                            <div className='pl-2 text-sm font-normal xl:pl-0 md:text-base xl:text-lg font-roboto'>{item.title}</div>
                                        </div>
                                        <div className='w-1/3 mx-auto'>
                                            <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.optinly ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                        </div>
                                        <div className='w-1/3 pr-10 text-right md:pr-32 lg:pr-20'>
                                            <img className='w-4 h-4 lg:w-6 lg:h-6' src={item.integrationApp ? Tick : Wrong} alt={item.optinly ? "Yes" : "No"}/>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    
                </div>
            </section>
        </>
    )
}

export default ComparisonTable
